// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-navigation .signup-navigation-link{background:#0000}.top-navigation .signup-navigation-link .sign-up-overlay-link,.top-navigation .signup-navigation-link .sign-up-overlay-link:after{font-size:.875rem;color:#fff!important}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
